module.exports = __webpack_public_path__ + "static/media/recent.16917bba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/games/recent.png
// module id = 825
// module chunks = 7